<template>
  <div v-if="modelValue" class="modal-overlay">
    <div class="modal-content">
      <h2>서비스 이용 불가</h2>
      <p>Lydia가 부족하여 이 서비스를 이용할 수 없습니다.</p>
      <div class="modal-buttons">
        <button @click="handleCharge">충전</button>
        <button @click="handleConfirm">취소</button>
      </div>
    </div>
  </div>
</template>

<script setup>
  // dfeineProps and defineEmits are compiler macro. so no need to import
  import { defineProps, defineEmits } from 'vue'

  const props = defineProps({
    modelValue: {
      type: Boolean,
      required: true,
    },
  })

  const emit = defineEmits(['update:modelValue', 'confirm', 'charge'])

  const handleConfirm = () => {
    emit('update:modelValue', false) // 모달 닫기
    emit('confirm') // 확인 이벤트 발생
  }

  const handleCharge = () => {
    emit('update:modelValue', false) // 모달 닫기
    emit('charge') // 충전 이벤트 발생
  }
</script>

<style scoped>
  /* 모달 관련 스타일 (SetupUserData.vue 참고) */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: var(--device-width);
    max-width: 480px; /* 최대 너비 설정 */
    margin: auto;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* 다른 요소 위에 표시 */
  }

  .modal-content {
    background-color: white;
    padding: 1rem; /* SetupUserData.vue와 유사하게 2rem 사용 */
    border-radius: 12px; /* SetupUserData.vue와 유사하게 12px 사용 */
    text-align: center;
    width: 90%;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2); /* 그림자 추가 */
    color: #333; /* SetupUserData.vue와 유사하게 텍스트 색상 설정 */
  }

  .modal-content h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: var(--font-size-12);
    color: #333;
  }

  .modal-content p {
    margin-bottom: 1rem;
    font-size: var(--font-size-10);
    color: #555;
  }

  .modal-buttons {
    margin-top: 1.5rem; /* SetupUserData.vue와 유사하게 margin-top 조정 */
    display: flex;
    justify-content: center;
    gap: 10px; /* 버튼 사이 간격 */
  }

  .modal-buttons button {
    padding: 0.7rem 1.5rem; /* SetupUserData.vue와 유사하게 padding 설정 */
    border: none;
    border-radius: 6px; /* SetupUserData.vue와 유사하게 border-radius 설정 */
    cursor: pointer;
    font-size: var(
      --font-size-10
    ); /* SetupUserData.vue와 유사하게 font-size 설정 */
    transition: background-color 0.3s ease;
  }
  .modal-buttons button:first-child {
    background-color: #4caf50;
    color: white;
  }

  .modal-buttons button:last-child {
    background-color: #f44336;
    color: white;
  }
</style>
